var o;!function(o){o.Control="control",o.Off="off",o.On="on"}(o||(o={}));export{o as OnOffTreatmentsEnum};
